import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { useHeroLookup } from "@/features/matches";

import type { HighlightView } from "../../model/Highlight";
import { isOutnumbered } from "../../model/isOutnumbered";
import { useHighlightTitle } from "../HighlightParts";

const CAPTION = msg`{title} on {hero}. Found by relock.gg`;
const CAPTION_VERSUS = msg`{title} on {hero}, {us} vs {them}. Found by relock.gg`;

// Подпись к посту со ссылкой: «Тройное убийство на Victor, 2 против 4. Нашёл relock.gg».
export const useShareCaption = (): ((highlight: HighlightView) => string) => {
  const { i18n } = useLingui();
  const title = useHighlightTitle();
  const hero = useHeroLookup();
  return (highlight) => {
    const values = { title: title(highlight), hero: hero(highlight.hero_id).name };
    const { details } = highlight;
    if (highlight.kinds[0] === "multikill" && isOutnumbered(details)) {
      return i18n._({
        ...CAPTION_VERSUS,
        values: { ...values, us: (details.allies_near ?? 0) + 1, them: details.enemies_near ?? 0 },
      });
    }
    return i18n._({ ...CAPTION, values });
  };
};
